import React from 'react'
import Modal from 'widgets/modals/Modal'
import AutoLogoutCountdown from 'widgets/auth/AutoLogoutCountdown'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'

export default function AutoLogoutModal ({ ...forwardProps }) {
  return (
    <Modal {...forwardProps}>
      <UI.SecondaryHeading>
        <Translation name='auth.auto_logout.in' />
        <span> <AutoLogoutCountdown />s</span>
      </UI.SecondaryHeading>
      <UI.Text>
        <Translation name='auth.auto_logout.make_action' />
      </UI.Text>

    </Modal>
  )
}
